import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FeaturesConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import {
  PromotionsModule,
  IconModule,
  MediaModule,
  ItemCounterModule,
  OutletModule,
  CardModule,
} from '@spartacus/storefront';
import { CartCouponModule, CartSharedModule } from '@spartacus/cart/base/components';
import { KnBrOrderSummaryComponent } from './kn-br-order-summary/kn-br-order-summary.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        CartCouponModule,
        ReactiveFormsModule,
        UrlModule,
        NgbModule,
        PromotionsModule,
        I18nModule,
        IconModule,
        MediaModule,
        ItemCounterModule,
        FeaturesConfigModule,
        OutletModule,
        CardModule,
        CartSharedModule,
        KnBrOrderSummaryComponent,
    ],
    exports: [KnBrOrderSummaryComponent],
})
export class KnBrCartSharedModule {}
